import { IFinancialEntry, IFinancialFilter, Iordem, IordemExpense } from "../types/financial";
import api from "./api";

export interface IPlanoContas {
  uid_plano_contas: string;
  uid_estabelecimento: string;
  uid_plano_contas_pai: string | null;
  codigo_classificacao: string;
  nome: string;
  tipo: "receita" | "despesa" | "ambos";
  ativo: boolean;
  tem_vinculos: boolean;
  nome_pai?: string | null;
}

export interface IChartOfAccountsFilter {
  uid_estabelecimento?: string;
  ativo?: boolean;
  tipo?: "receita" | "despesa" | "ambos";
  somente_raiz?: boolean;
}

export const loadChartOfAccounts = async (
  search: string,
  page: number,
  filter: IChartOfAccountsFilter,
) => {
  try {
    const res = await api.get(`/accountChart/chartOfAccounts`, {
      params: { search, page, filter: JSON.stringify(filter) },
    });

    return res.data?.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro ao carregar plano de contas!"
    );
  }
};

export const toggleChartOfAccountsStatus = async (uid: string) => {
  try {
    const res = await api.patch(`/accountChart/toggleStatus/${uid}`);

    if (res?.data?.status === 200) {
      console.log("Status da conta alterado com sucesso");
      return res.data;
    } else {
      const message =
        res?.data?.message || "Erro inesperado ao alterar status da conta";
      console.error(message);
      throw new Error(message);
    }
  } catch (error: unknown) {
    let errorMessage = "Erro desconhecido ao alterar status da conta";

    if (error instanceof Error) {
      errorMessage = error.message;
    } else if (typeof error === "string") {
      errorMessage = error;
    } else if (error && typeof (error as any).message === "string") {
      errorMessage = (error as any).message;
    }

    console.error(errorMessage);
    throw new Error(errorMessage);
  }
};

export const cancelChartOfAccounts = async (uid: string) => {
  try {
    const res = await api.patch(`/accountChart/cancelAccount/${uid}`);

    if (res?.data?.status === 200) {
      console.log("Conta excluída com sucesso");
      return res.data;
    } else {
      const message = res?.data?.message || "Erro inesperado ao excluir conta";
      console.error(message);
      throw new Error(message);
    }
  } catch (error: unknown) {
    let errorMessage = "Erro desconhecido ao excluir conta";

    if (error instanceof Error) {
      errorMessage = error.message;
    } else if (typeof error === "string") {
      errorMessage = error;
    } else if (error && typeof (error as any).message === "string") {
      errorMessage = (error as any).message;
    }

    throw new Error(errorMessage);
  }
};

interface PlanOfAccountsData {
  uid_plano_contas?: string;
  uid_plano_contas_pai?: string | null;
  codigo_classificacao: string;
  nome: string;
  tipo: "receita" | "despesa" | "ambos";
  ativo: boolean;
}

export const getSuggestedCode = async (uid_pai?: string | null) => {
  try {
    const res = await api.get(`/accountChart/suggestCode`,{
      params: {
        uid_pai
      }
    });
    return res.data.data.code;
  } catch (error) {
    console.error("Erro ao sugerir código", error);
    return "";
  }
};

export const registerOrEditPlanOfAccounts = async (
  data: PlanOfAccountsData,
) => {
  try {
    const res = await api.post(
      `/accountChart/registerOrEditChartOfAccounts`,
      data,
    );

    return res.data;
  } catch (error: any) {
    console.error(
      "Erro ao cadastrar/editar conta:",
      error.response?.data || error,
    );
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.errors?.[0] ||
        error?.message ||
        "Erro desconhecido ao salvar conta!",
    );
  }
};


export interface ICostCenterFilter {
  ativo?: boolean;
}

export const loadCostCenters = async (
  search: string,
  page: number,
  filter: ICostCenterFilter,
) => {
  try {
    const res = await api.get(`/costCenter/centros-custo`, {
      params: { search, page, filter: JSON.stringify(filter) },
    });

    return res.data?.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro ao carregar centros de custo!"
    );
  }
};

export const cancelCostCenter = async (uid: string) => {
  try {
    const res = await api.patch(`/costCenter/cancelCostCenter/${uid}`);

    if (!res || !res.data || res.data.data === null) {
      console.log("Centro de custo cancelado com sucesso");
      return res?.data;
    } else {
      const message = res?.data?.message || "Erro inesperado no cancelamento";
      console.error(message);
      throw new Error(message);
    }
  } catch (error: unknown) {
    let errorMessage = "Erro desconhecido ao cancelar centro de custo";

    if (error instanceof Error) {
      errorMessage = error.message;
    } else if (typeof error === "string") {
      errorMessage = error;
    } else if (error && typeof (error as any).message === "string") {
      errorMessage = (error as any).message;
    }

    console.error(errorMessage);

    return null;
  }
};

export const toggleCostCenterStatus = async (uid: string) => {
  try {
    const res = await api.patch(`/costCenter/toggleStatus/${uid}`);

    if (res?.data?.status === 200) {
      console.log("Status do centro de custo alterado com sucesso");
      return res.data;
    } else {
      const message =
        res?.data?.message ||
        "Erro inesperado ao alterar status do centro de custo";
      console.error(message);
      throw new Error(message);
    }
  } catch (error: unknown) {
    let errorMessage = "Erro desconhecido ao alterar status do centro de custo";

    if (error instanceof Error) {
      errorMessage = error.message;
    } else if (typeof error === "string") {
      errorMessage = error;
    } else if (error && typeof (error as any).message === "string") {
      errorMessage = (error as any).message;
    }

    console.error(errorMessage);
    throw new Error(errorMessage);
  }
};

export interface CostCenterData {
  uid_centro_custo?: string;
  nome: string;
  ativo: boolean;
}

export const registerOrEditCostCenter = async (
  costCenterData: CostCenterData,
) => {
  try {
    const res = await api.post(
      "/costCenter/registerOrEditCostCenter",
      costCenterData,
    );

    return res.data;
  } catch (error: any) {
    console.error(
      "Erro ao cadastrar/editar centro de custo:",
      error.response?.data || error,
    );
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.errors?.[0] ||
        error?.message ||
        "Erro desconhecido ao cadastrar centro de custo!",
    );
  }
};

export const cancelFinancialEntry = async (uid: string) => {
  try {
    const res = await api.patch(
      `/financial/cancelFinancialEntry/${uid}`,
    );

    if (res?.data?.status === 200) {
      console.log("Lançamento financeiro cancelado com sucesso");
      return res.data;
    } else {
      const message = res?.data?.message || "Erro inesperado no cancelamento";
      console.error(message);
      throw new Error(message);
    }
  } catch (error: unknown) {
    let errorMessage = "Erro desconhecido ao cancelar lançamento financeiro";

    if (error instanceof Error) {
      errorMessage = error.message;
    } else if (typeof error === "string") {
      errorMessage = error;
    } else if (error && typeof (error as any).message === "string") {
      errorMessage = (error as any).message;
    }

    console.error(errorMessage);
    throw new Error(errorMessage);
  }
};

export const fetchPaymentTypeByTitle = async (titulo: string) => {
  try {
    const res = await api.post("/financial/getPaymentTypeByTitle", { titulo });

    return res?.data?.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(error.message || "Erro desconhecido!");
    } else {
      throw new Error("Erro desconhecido!");
    }
  }
};

export const loadExpensesEntries = async (
  search: string,
  page: number,
  filter: IFinancialFilter,
  orderTable?: IordemExpense,
) => {
  try {
    const res = await api.get(`/financial/accountsPayable`, {
      params: { search, page, filter: JSON.stringify(filter), orderTable },
    });

    return res.data?.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro ao carregar lançamentos financeiros!"
    );
  }
};

export const loadFinancialEntries = async (
  search: string,
  page: number,
  filter: IFinancialFilter,
  orderTable?: Iordem,
) => {
  try {
    const res = await api.get(`/financial/accountsReceivable`, {
      params: { search, page, filter: JSON.stringify(filter), orderTable },
    });

    return res.data?.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro ao carregar lançamentos financeiros!"
    );
  }
};

export const markFinancialEntryAsPaid = async (
  uid: string,
  data_pagamento?: string,
  uid_tipo_pagamento?: string,
) => {
  try {
    const payload: any = {};
    if (data_pagamento) payload.data_pagamento = data_pagamento;
    if (uid_tipo_pagamento) payload.uid_tipo_pagamento = uid_tipo_pagamento;

    const res = await api.patch(
      `/financial/markFinancialEntryAsPaid/${uid}`,
      payload,
    );

    if (res?.data?.status === 200) {
      console.log("Lançamento financeiro marcado como pago com sucesso");
      return res.data;
    } else {
      const message =
        res?.data?.message || "Erro inesperado ao marcar como pago";
      console.error(message);
      throw new Error(message);
    }
  } catch (error: unknown) {
    let errorMessage =
      "Erro desconhecido ao marcar lançamento financeiro como pago";

    if (error instanceof Error) {
      errorMessage = error.message;
    } else if (typeof error === "string") {
      errorMessage = error;
    } else if (error && typeof (error as any).message === "string") {
      errorMessage = (error as any).message;
    }

    console.error(errorMessage);
    throw new Error(errorMessage);
  }
};

export const refoundFinancialEntry = async (
  uid_financeiro_lancamento: string,
) => {
  try {
    const res = await api.patch(
      `/financial/refoundFinancialEntry/${uid_financeiro_lancamento}`,
    );

    return res.data;
  } catch (error: any) {
    if (error.code === "DATABASE_ERROR") {
      error.message = "Erro ao salvar aluno";
    }

    throw error;
  }
};


export const fetchFinancialEntryByUid = async ({
  uid,
  type,
}: {
  uid: string;
  type: "pagar" | "receber";
}): Promise<IFinancialEntry> => {
  const response = await api.get(
    `/financial/financialEntryByUid/${uid}`,
    {
      params: { type },
    },
  );
  return response.data?.data;
};

export const fetchPaymentTypes = async () => {
  try {
    const res = await api.get("/products/loadAllPaymentTypes");

    return res?.data?.data.filter(
      (item: { syncanmom?: any }) => !item.syncanmom,
    );
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(error.message || "Erro desconhecido!");
    } else {
      throw new Error("Erro desconhecido!");
    }
  }
};

export const registerOrEditFinancialEntry = async (financialData: {
  uid_financeiro_lancamento?: string;
  tipo: "pagar" | "receber";
  numero_documento: string | null;
  descricao: string;
  uid_cliente?: string;
  uid_fornecedor?: string;
  uid_pedido?: string | null;
  parcela: number;
  data_emissao: Date;
  data_vencimento: Date;
  data_pagamento?: Date;
  status: "aberto" | "pago" | "atrasado" | "cancelado";
  uid_tipo_pagamento?: string;
  observacao?: string;
  uid_plano_contas?: string | null;
  uid_centro_custo?: string | null;
  uid_conta_financeira?: string | null;
  codigo_estabelecimento?: number;
}) => {
  try {
    const res = await api.post(
      "/financial/registerOrEditFinancialEntry",
      financialData,
    );

    return res.data;
  } catch (error: any) {
    console.error(
      "Erro ao cadastrar/editar lançamento financeiro:",
      error.response?.data || error,
    );
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.errors?.[0] ||
        error?.message ||
        "Erro desconhecido ao cadastrar lançamento financeiro!",
    );
  }
};
